export default __webpack_public_path__ + "static/media/18.ab60d298.png";